module.exports = __webpack_public_path__ + "img/album07_22.f06358d5.jpg";